<template>
  <div>
    <div class="md-layout" v-if="node">
      <div class="md-layout-item">
        <article class="node">
          <header class="md-layout md-gutter md-alignment-center-center">
            <div class="md-layout-item md-size-20">
              <md-button class="md-fab" v-if="node.field_voice_files.length" @click="playPauseAudio()">
                <md-icon v-if="!audioRunning">play_arrow</md-icon>
                <md-icon v-else>pause</md-icon>
              </md-button>
            </div>
            <div class="md-layout-item">
              <h1 class="md-headline text-right">{{ node.title[0].value }}</h1>
              <h2 class="md-subheading text-right" v-if="term">{{ term.name[0].value }}</h2>
            </div>
          </header>

          <md-card v-if="node.field_youtube_url.length" id="video">
            <md-card-content>
              <div class="md-subheading" style="margin-bottom: 20px;">
                <md-icon>video_library</md-icon>
                Video
              </div>
              <iframe :src="node.field_youtube_url[0].value" height="400" frameborder="0" style="width:100%" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </md-card-content>
          </md-card>

          <md-card id="information">
            <md-card-content>
              <div v-html="node.body[0].processed" class="md-body-2"></div>
            </md-card-content>
          </md-card>

          <md-card v-if="node.field_voice_files.length" id="audio">
            <md-card-content>
              <div class="md-subheading">
                <md-icon>audiotrack</md-icon>
                {{ translations[$store.state.lang].node.audio }}
              </div>
              <audio controls ref="audiotrack">
                <source :src="node.field_voice_files[0].url" type="audio/mpeg">
                Your browser does not support the <code>audio</code> element.
              </audio>
            </md-card-content>
          </md-card>

          <md-card v-if="node.field_images.length" id="gallery">
            <md-card-content>
              <div class="md-subheading">
                <md-icon>collections</md-icon>
                {{ translations[$store.state.lang].node.gallery }}
              </div>
            </md-card-content>
            <md-card-media-cover v-for="image in node.field_images" :key="image.target_id">
              <md-card-media md-ratio="16:9">
                <img :src="image.url|imageStyle" :alt="image.alt">
              </md-card-media>
              <md-card-area>
                <md-card-header>
                  <span class="md-subheader">{{ image.alt }}</span>
                </md-card-header>
                <md-card-actions>
                  <md-button class="md-icon-button" @click="expandImage(image)">
                    <md-icon>zoom_out_map</md-icon>
                  </md-button>
                </md-card-actions>
              </md-card-area>
            </md-card-media-cover>
          </md-card>

          <md-dialog v-if="node.field_images.length" :md-active.sync="showDialog" :md-fullscreen="false">
            <img :src="dialogImage" alt>
          </md-dialog>

          <md-card v-if="node.field_links.length" id="links">
            <md-card-content>
              <div class="md-subheading" style="margin-bottom: 20px;">
                <md-icon>link</md-icon>
                {{ translations[$store.state.lang].node.links }}
              </div>
              <md-list>
                <md-list-item :href="link.uri" target="_blank" v-for="link in node.field_links">
                  <md-icon>open_in_new</md-icon>
                  <span class="md-list-item-text md-body-1">{{ link.title }}</span>
                  <md-divider></md-divider>
                </md-list-item>
              </md-list>
            </md-card-content>
          </md-card>

        </article>
      </div>
    </div>

    <md-bottom-bar md-type="shift" class="md-accent" v-if="node">
      <md-bottom-bar-item v-if="node.field_youtube_url.length" md-icon="video_library" md-label="Videos" @click="scrollTo('video')"></md-bottom-bar-item>
      <md-bottom-bar-item md-icon="info" :md-label="translations[$store.state.lang].node.info" @click="scrollTo('information')"></md-bottom-bar-item>
      <md-bottom-bar-item v-if="node.field_voice_files.length" md-icon="audiotrack" :md-label="translations[$store.state.lang].node.audio" @click="scrollTo('audio')"></md-bottom-bar-item>
      <md-bottom-bar-item v-if="node.field_images.length" md-icon="collections" :md-label="translations[$store.state.lang].node.gallery" @click="scrollTo('gallery')"></md-bottom-bar-item>
      <md-bottom-bar-item v-if="node.field_links.length" md-icon="link" :md-label="translations[$store.state.lang].node.links" @click="scrollTo('links')"></md-bottom-bar-item>
    </md-bottom-bar>

  </div>

</template>

<script>

    import {API} from "@/variables";
    import {LANG} from "@/lang";

    export default {
        name: 'vue-node',
        metaInfo() {
              return {
                  title: this.node ? this.node.title[0].value : ''
              }
        },
        data() {
            return {
                translations: LANG,
                nid: null,
                lang: null,
                node: null,
                term: null,
                audioRunning: false,
                showDialog: false,
                dialogImage: ''
            }
        },
        mounted() {
            this.nid = this.$route.params.nid;
            this.lang = this.$route.params.lang;
            this.$store.commit('language', this.$route.params.lang);

            this.getNode(this.nid, this.lang);
        },
        methods: {
            getNode(nid, lang) {

                this.$http.get(API.protocol + API.ip + '/' + lang + '/node/' + nid + '?_format=json', {
                    header: {
                        'Content-Type': 'application/hal+json',
                    },
                    withCredentials: true
                })
                    .then((resp) => {
                        this.node = resp.data;
                        this.getPlace(resp.data.field_place[0].target_id);
                    })

            },
            getPlace(tid) {
                this.$http.get(API.protocol + API.ip + '/' + this.lang + '/taxonomy/term/' + tid + '?_format=json', {
                    header: {
                        'Content-Type': 'application/hal+json',
                    },
                    //withCredentials: true
                })
                    .then((resp) => {
                        this.term = resp.data;
                    })
            },
            expandImage(image) {
                this.dialogImage = image.url;
                this.showDialog = true;
            },
            scrollTo(id) {
                let element = document.getElementById(id);
                element.scrollIntoView({behavior: 'smooth', block: 'center'})
            },
            playPauseAudio() {
                if (this.$refs.audiotrack.paused) {
                    this.$refs.audiotrack.play();
                    this.audioRunning = true;
                } else {
                    this.$refs.audiotrack.pause();
                    this.audioRunning = false;
                }
            },
        },
        filters: {
            imageStyle(value) {
                return value.replace('/sites/default/files/', '/sites/default/files/styles/mobile/public/') + '.jpg';
            }
        }
    }
</script>

<style lang="scss" scoped>
  .node {
    margin-bottom: 100px;
  }

  #gallery {
    .md-card-media-cover {
      .md-card-header {
        width: 80%;
      }

      .md-card-actions {
        width: 20%;
      }
    }
  }
</style>
